import { useState } from "react";

const NAV_LINKS = [
  { href: "/vehicles", label: "Our Vehicles" },
  { href: "/day-trips", label: "Day Trips & Tours" },
  { href: "/airport-transfers", label: "Airport Transfers" },
  { href: "/feedback", label: "Feedback" },
];

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/70 border-b border-white/40 shadow-lg">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <a href="/" className="flex items-center hover:opacity-90 transition-opacity">
          <img
            src="/images/araliya-tours-logo.png"
            alt="Araliya Tours"
            className="h-10 sm:h-16 w-auto drop-shadow-lg filter"
          />
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-2 sm:gap-3">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="inline-flex items-center px-4 py-2.5 text-sm font-semibold text-gray-700 bg-white/80 backdrop-blur rounded-xl border border-gray-200/60 shadow-sm transition-all duration-200 hover:bg-white hover:border-gray-300 hover:shadow-md hover:scale-105"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden flex flex-col justify-center items-center w-10 h-10 gap-1.5"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-gray-700 transition-all duration-200 ${open ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block w-6 h-0.5 bg-gray-700 transition-all duration-200 ${open ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-0.5 bg-gray-700 transition-all duration-200 ${open ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <nav className="md:hidden border-t border-white/40 bg-white/90 backdrop-blur px-6 py-4 flex flex-col gap-2">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="px-4 py-3 text-sm font-semibold text-gray-700 bg-white/80 rounded-xl border border-gray-200/60 shadow-sm hover:bg-white transition-all"
              onClick={() => setOpen(false)}
            >
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}

export default Header;
